export const paginationLeftButton
  = "size-10 rounded-md bg-neutral-50 text-neutral-500 rtl:[&_span:first-child]:rotate-180 disabled:bg-neutral-50 hover:bg-neutral-50";

export const paginationRightButton
  = "size-10 rounded-md bg-neutral-50 text-neutral-500 rtl:[&_span:last-child]:rotate-180 disabled:bg-neutral-50 hover:bg-neutral-50";

export const roundIconButton
  = "bg-[#F3F1EC] active:bg-[#F3F1EC] disabled:bg-[#F3F1EC] hover:bg-[#F3F1EC] text-primary size-[44px] xl:size-[48px] outline-none";

export const roundIconButtonUi = {
  base: roundIconButton,
};
